import { render, staticRenderFns } from "./uiCard.vue?vue&type=template&id=28c1c386&scoped=true"
import script from "./uiCard.vue?vue&type=script&lang=js"
export * from "./uiCard.vue?vue&type=script&lang=js"
import style0 from "./uiCard.vue?vue&type=style&index=0&id=28c1c386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c1c386",
  null
  
)

export default component.exports